import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/explore', label: 'Explore' },
    { path: '/dark-tourism-explained', label: 'Dark Tourism' },
    { path: '/wall-of-stories', label: 'Hidden Stories' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1a1c1b]/95 backdrop-blur-md border-b border-[#3a2222]">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img 
              src="/images/logo.jpg"
              alt="Dark Tourism Malaysia"
              className="h-10 w-10 rounded-full object-cover"
            />
            <span className="text-white font-semibold text-sm hidden sm:inline tracking-wide">DARK TOURISM MALAYSIA</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-4 py-2 text-white/90 hover:text-[#dc2626] transition-colors text-sm font-medium"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-[#3a2222]">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-white/90 hover:text-[#dc2626] hover:bg-[#302f2c] transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
